import { request } from "@/network/request.js";


// 项目(需求，任务，问题)列表  type 1 2 3
export function get_project_damand_list(params) {
	return request({
		url: '/hkt/project/get_project_damand_list',
		params,
	})
}

// 项目(需求，任务，问题) 详情  
// type 1 2 3
// project_demand_id  id 
export function get_project_damand_details(params) {
	return request({
		url: '/hkt/project/get_project_damand_details',
		params,
	})
}

// 单独修改

export function update_project_damand_field(data) {
    return request({
        url: '/hkt/project/update_project_damand_field',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
};
export function updata_project_field(data) {
    return request({
        url: '/hkt/project/updata_project_field',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
};


// 需求的子列表
export function get_project_damand_son(params) {
	return request({
		url: '/hkt/project/get_project_damand_son',
		params,
	})
}





// 删除需求
// project_demand_id
// type :1，2，3
export function del_project_damand(params) {
	return request({
		url: '/hkt/project/del_project_damand',
		params,
	})
}


// 项目编号
export function get_project_demand_code() {
	return request({
		url: '/hkt/project/get_project_demand_code',
		params: {},
	})
}

// 需求级别
export function get_project_damand_level() {
	return request({
		url: '/hkt/project/get_project_damand_level',
		params: {},
	})
}
// 需求状态 
export function get_project_damand_status() {
	return request({
		url: '/hkt/project/get_project_damand_status',
		params: {},
	})
}




// 新建项目 需求
export function add_project_damand(data) {
    return request({
        url: '/hkt/project/add_project_damand',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
};


// 项目(需求，任务，问题) 详情 编辑 
// type 1 2 3
// project_demand_id  id 
export function update_project_damand(data) {
	return request({
		url: '/hkt/project/update_project_damand',
		method: 'post',
		headers: {
		    'Content-Type': 'multipart/form-data'
		},
		data,
	})
}
